import React from "react";
import PropTypes from "prop-types";

import BoolControl from "./BoolControl";

const RightsUser = props => (
	<form
		className="user-group">
		<BoolControl i18n_key="Overview" prop="overview"
			local={props.user} handleChange={props.handleChange} />
		<BoolControl i18n_key="Analysis" prop="analytics"
			local={props.user} handleChange={props.handleChange} />
		<BoolControl i18n_key="Energy Balancing" prop="energy_balancing"
			local={props.user} handleChange={props.handleChange} />
		<BoolControl i18n_key="Maintenance" prop="maintenance"
			local={props.user} handleChange={props.handleChange} />
		<BoolControl i18n_key="Error Log" prop="errors"
			local={props.user} handleChange={props.handleChange} />
		<BoolControl i18n_key="Settings" prop="settings"
			local={props.user} handleChange={props.handleChange} />
	</form>
);

RightsUser.propTypes = {
	user: PropTypes.object.isRequired,
	handleChange: PropTypes.func.isRequired
};

export default RightsUser;
